/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 4e002a63b07b
 */

import * as z from "zod";

export type Settings = string | boolean;

export const Settings$zodSchema: z.ZodType<Settings> = z.union([
  z.string(),
  z.boolean(),
]);

/**
 * An upload preset as returned in list responses. Most settings values are raw strings, but some boolean fields may be returned as native booleans.
 */
export type UploadPresetSummary = {
  name: string;
  unsigned?: boolean | undefined;
  settings?: { [k: string]: string | boolean } | undefined;
  external_id: string;
};

export const UploadPresetSummary$zodSchema: z.ZodType<UploadPresetSummary> = z
  .object({
    external_id: z.string().describe(
      "The unique identifier for the upload preset.",
    ),
    name: z.string().describe("The name of the upload preset."),
    settings: z.record(
      z.string(),
      z.union([
        z.string(),
        z.boolean(),
      ]),
    ).optional().describe(
      "Preset configuration settings. Most values are strings (e.g., tags are comma-separated, context is pipe-separated key=value pairs), but some boolean fields may be returned as native booleans.",
    ),
    unsigned: z.boolean().optional().describe(
      "Whether the upload preset allows unsigned uploads.",
    ),
  }).describe(
    "An upload preset as returned in list responses. Most settings values are raw strings, but some boolean fields may be returned as native booleans.",
  );
